var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-ssr',[_c('lazy-component',{staticClass:"yt-youtube-player",on:{"show":_vm.init}},[_c('div',{staticClass:"yt-youtube-player__container",attrs:{"data-plyr-provider":_vm.detectedTypeUrl.provider,"data-plyr-embed-id":_vm.detectedTypeUrl.id}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }